import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mmb-web-app-welcome-banner',
  templateUrl: './welcome-banner.component.html',
  styleUrls: ['./welcome-banner.component.scss']
})
export class WelcomeBannerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
